/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_List_Filter_All_PositionsInputs */

const vi_lot_list_filter_all_positions = /** @type {(inputs: Lot_List_Filter_All_PositionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả vị trí`)
};

/**

* @param {Lot_List_Filter_All_PositionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_list_filter_all_positions = /** @type {((inputs?: Lot_List_Filter_All_PositionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_List_Filter_All_PositionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_list_filter_all_positions(inputs)
});